import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LoginComponent} from "./login/login.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import { LogoutComponent } from './logout/logout.component';
import {ButtonModule} from "primeng/button";
import {PrimeNgModule} from "../prime-ng/prime-ng.module";

const routes = [
  {path: 'login', component: LoginComponent},
  {path: 'logout', component: LogoutComponent},
];

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(routes),
        ButtonModule,
        PrimeNgModule
    ]
})

export class AuthModule {
}
